import { Box, Flex, Text } from "@radix-ui/themes";
import { DashIcon } from "@radix-ui/react-icons";

const BulletPoints: React.FC<{
  points: { text: string }[];
}> = ({ points }) => {
  return (
    <Box>
      <ul style={{ listStyle: "none", margin: 0, padding: 0 }}>
        {points.map((point, index) => {
          return (
            <li key={index}>
              <Text>
                <Flex gap="2">
                  <Flex mt="5px">
                    <DashIcon />
                  </Flex>
                  {point.text}
                </Flex>
              </Text>
            </li>
          );
        })}
      </ul>
    </Box>
  );
};

export default BulletPoints;
